import styled from 'styled-components';
import { Menu } from '@/ui';
import { COLORS, pickThemeFontStyles } from '@/theme';

export const StyledPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const StyledMainTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 2rem;
  padding-bottom: 0;
  background-color: ${COLORS.GRAY};
  border-bottom: 1px solid ${COLORS.LIGHT_GRAY};
`;

export const StyledHeaderRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
`;

export const StyledPageTitle = styled.div`
  ${pickThemeFontStyles('30', '30', 'BOLD')};
  color: ${COLORS.BLACK_PRIMARY};
`;

export const StyledPageDescription = styled.p`
  margin: 0.5rem 0 0;
  max-width: 40rem;
  ${pickThemeFontStyles('14', '22', 'NORMAL')};
  color: ${COLORS.IRON_GRAY};
`;

export const StyledMenu = styled(Menu)`
  width: 100%;

  &&& .ant-menu-item-selected::after,
  &&& .ant-menu-item-active::after {
    border-bottom-color: ${COLORS.YELLOW_PRIMARY} !important;
  }
`;

export const StyledContentBlock = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 1.5rem 2rem 2rem;
`;
